// Lightweight SVG "signal network": static nodes and links with CSS-driven packets travelling along them.
const nodes = [
  [120, 160], [340, 90], [560, 220], [780, 120], [1010, 210], [1260, 110], [1380, 300],
  [200, 420], [460, 470], [700, 380], [930, 470], [1180, 420], [90, 700], [380, 760], [640, 650], [880, 760], [1120, 660], [1350, 760],
];
const links = [
  [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [0, 7], [7, 8], [8, 9], [9, 2], [9, 10], [10, 4], [10, 11], [11, 6],
  [7, 12], [12, 13], [13, 14], [14, 8], [14, 15], [15, 10], [15, 16], [16, 11], [16, 17], [17, 6],
];
const signals = [0, 3, 8, 10, 14, 19, 22];

export const SignalNetwork = ({ className = "" }) => (
  <svg viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true" className={`pointer-events-none ${className}`}>
    <defs>
      <radialGradient id="sn-fade" cx="50%" cy="40%" r="70%">
        <stop offset="0" stopColor="#fff" stopOpacity="1" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </radialGradient>
      <mask id="sn-mask"><rect width="1440" height="900" fill="url(#sn-fade)" /></mask>
    </defs>
    <g mask="url(#sn-mask)">
      {links.map(([a, b], i) => (
        <line key={i} x1={nodes[a][0]} y1={nodes[a][1]} x2={nodes[b][0]} y2={nodes[b][1]} stroke="rgba(249,115,22,0.13)" strokeWidth="1" />
      ))}
      {signals.map((li, i) => {
        const [a, b] = links[li];
        return (
          <line key={`s${i}`} x1={nodes[a][0]} y1={nodes[a][1]} x2={nodes[b][0]} y2={nodes[b][1]}
            stroke="#FB923C" strokeWidth="1.6" strokeLinecap="round" pathLength="100"
            className="tc-signal" style={{ animationDelay: `${i * 0.9}s`, animationDuration: `${4 + (i % 3)}s` }} />
        );
      })}
      {nodes.map(([x, y], i) => (
        <g key={`n${i}`}>
          <circle cx={x} cy={y} r="2.2" fill="#F97316" opacity="0.55" />
          {i % 4 === 0 && <circle cx={x} cy={y} r="2.2" fill="none" stroke="#F97316" className="tc-node-ping" style={{ animationDelay: `${i * 0.35}s` }} />}
        </g>
      ))}
    </g>
  </svg>
);
